import { render, staticRenderFns } from "./TaggingDetails.vue?vue&type=template&id=d742d622"
import script from "./TaggingDetails.vue?vue&type=script&lang=js"
export * from "./TaggingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports